module.exports = __webpack_public_path__ + "img/logo_hide.509805c5.svg";